export default __webpack_public_path__ + "static/media/search-dark.e7e075c4.svg";